<template>
     <v-row>
    <v-col>
  <v-container fluid>
    <v-row>
      <v-col class="d-flex flex-row align-center">
        <v-btn text @click="()=>{this.$router.go(-1)}"><v-icon dark>mdi-arrow-left</v-icon></v-btn>
        <h1>{{plural}}</h1>
        <v-btn class="ml-2" small fab color="info" @click="newForm"><v-icon>mdi-plus</v-icon></v-btn>
        <v-progress-circular
            indeterminate
            color="green"
            v-if="dataLoader"
            style="margin-left: 10px;"
        ></v-progress-circular>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="5">
        <span class="d-flex flex-row">
          <h3 v-if="isCreate">Create {{singular}}</h3>
          <h3 v-else>Edit ID:{{form.id}} | {{form.code}}</h3>
        </span>
        <span v-if="!isCreate" class="d-flex flex-row mb-2">
          <v-btn v-if="!isEditable" @click="isEditable=!isEditable">Edit</v-btn>
          <v-btn v-else @click="cancelForm">Cancel</v-btn>
          <v-btn class="ml-2" v-if="isEditable" @click="deleteData" color="error">Delete</v-btn>
        </span>
        <v-form :disabled="!isEditable && !isCreate" v-model="validForm">
          <span class="d-flex flex-column">
            <v-text-field :rules="requiredRules" outlined label="Code" hint="e.g. TTD" v-model="form.code"/>
            <v-text-field outlined label="Name" hint="e.g. Trinidad and Tobago Dollar" v-model="form.name"/>
          </span>
          <span class="d-flex flex-row align-center my-2">
            <h3>Denominations</h3>
            <v-btn fab color="info" x-small class="ml-2" @click="addDenomination"><v-icon>mdi-plus</v-icon></v-btn>
          </span>
          <span v-if="!form.denominations || form.denominations.length===0" class="red--text">At least one denomination is required.</span>
          <v-card outlined class="mb-1" v-for="(denom, d) of form.denominations" :key="d">
            <v-card-text class="d-flex flex-row align-center" style="gap: 8px;">
              <v-text-field outlined dense hide-details label="Label" hint="e.g. $100 or 25¢" v-model="denom.label"/>
              <v-text-field outlined dense hide-details label="Value" type="number" v-model="denom.value"/>
              <v-btn color="error" x-small fab @click="removeDenomination(d)"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-text>
          </v-card>
        </v-form>
        <span v-if="isEditable && !isCreate" class="d-flex flex-row mt-2">
          <v-btn :disabled="!validForm || !form.denominations || form.denominations.length===0" class="ml-1" color="success" @click="updateData" :loading="formLoader">Update</v-btn>
        </span>
        <span v-if="isCreate" class="d-flex flex-row mt-2">
          <v-btn :disabled="!validForm || !form.denominations || form.denominations.length===0" class="ml-1" color="success" @click="createData" :loading="formLoader">Save</v-btn>
        </span>
      </v-col>
      <v-col cols="12" md="7">
        <v-data-table mobile-breakpoint="0"
            :items="data"
            :headers="headers"
            :items-per-page="-1"
            @click:row="rowClick"
            :loading="dataLoader"
        >
          <template v-slot:item.denominations="{ item }">
            <span>{{ (item.denominations||[]).map(x => x.label).join(', ') }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
    </v-col>
   </v-row>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from "axios";

export default {
  name: 'Home',
  data () {
    return {
      dataLoader: false,
      formLoader: false,

      isEditable: false,
      isCreate: true,

      singular: "Currency",
      singularLower: "currency",
      plural: "Currencies",
      pluralLower: "currencies",

      requiredRules: [
        v => !!v || 'Field is required.'
      ],

      data: [],
      form: {},
      validForm: false,

      headers: [
        { text: 'ID', align: 'start', value: 'id' },
        { text: 'Code', value: 'code' },
        { text: 'Name', value: 'name' },
        { text: 'Denominations', value: 'denominations' }
      ]
    }
  },
  computed: {
    ...mapGetters(['getEndpoint'])
  },
  async mounted(){
    try {
      this.dataLoader = true;

      await this.fetchData();

    } finally {
      this.dataLoader = false;
    }
  },
  methods: {
    newForm(){
      this.form = {
        code: '',
        name: '',
        denominations: []
      }
      this.isEditable = true;
      this.isCreate = true;
    },
    addDenomination(){
      if(!this.form.denominations) this.form.denominations = [];
      this.form.denominations.push({label: '', value: 0});
    },
    removeDenomination(i){
      this.form.denominations.splice(i, 1);
    },
    rowClick(row){
      this.form = {...row, denominations: (row.denominations||[]).map(x => ({...x}))};

      this.isEditable = false;
      this.isCreate = false;
    },
    async cancelForm(){
      try{
        this.formLoader = true;

        await this.fetchData();

        let found = this.data.find(x=>x.id===this.form.id);
        this.form = {...found, denominations: (found.denominations||[]).map(x => ({...x}))};

        this.isEditable = false;
      }
      finally
      {
        this.formLoader = false;
      }
    },
    async fetchData(){
      try{
        this.dataLoader = true;

        let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}`)
        this.data = res.data.data
      }
      finally {
        this.dataLoader = false;
      }
    },
    async createData(){
      try{
        this.formLoader = true;

        await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.form)
        this.$snack(`${this.singular} created!`, "success");

        await this.fetchData();
      }
      finally {
        this.formLoader = false;
      }
    },
    async updateData(){
      try{
        this.formLoader = true;

        await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.form.id}`, this.form)

        this.$snack(`${this.singular} updated!`, "success");
      }
      finally {
        this.formLoader = false;
      }
    },
    async deleteData(){
      try{
        this.formLoader = true;

        await axios.delete(`${this.getEndpoint}/api/${this.pluralLower}/${this.form.id}`)
        this.$snack(`${this.singular} deleted!`, "success");

        await this.fetchData();

        this.newForm();
      }
      finally {
        this.formLoader = false;
      }
    }
  }
}
</script>
